import jQuery from 'jquery';
import jsCookie from 'js-cookie';
import { fetchRating } from './fetchRating';
import { EVENTS } from '../../constants';

const cookie = jsCookie.get('RDSP');
const isLoggedIn = cookie && JSON.parse(cookie).rp_uid;

const state = {
    isFetched: false,
    isShown: false,
};

const $body = jQuery(document.body);
const showRating = () => $body.toggleClass('js-rating-shown');

export const myRatingHandler = (e, { myRatings: isShown = false }) => {
    if (state.isShown === isShown) {
        return;
    }

    state.isShown = isShown;
    showRating();

    if (state.isFetched) {
        return;
    }

    if (isLoggedIn) {
        state.isFetched = true;
        fetchRating();
    }
};

export default () => jQuery(document).on(EVENTS.SETTINGS_CHANGED, myRatingHandler);



// WEBPACK FOOTER //
// ./lib/js/modules/myRating/index.js